import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Section from '../components/Section.jsx';
import { faq } from '../content.js';

export default function Faq() {
  return (
    <Section
      id="duvidas"
      eyebrow="Dúvidas frequentes"
      title="O que costumam perguntar"
      maxWidth="md"
    >
      {faq.map((item, index) => (
        <Accordion
          key={item.question}
          elevation={0}
          disableGutters
          sx={{
            bgcolor: 'transparent',
            borderBottom: '1px solid',
            borderColor: 'divider',
            '&::before': { display: 'none' },
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`faq-panel-${index}`}
            id={`faq-header-${index}`}
          >
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
              {item.question}
            </Typography>
          </AccordionSummary>
          <AccordionDetails id={`faq-panel-${index}`}>
            <Typography variant="body2" color="text.secondary">
              {item.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </Section>
  );
}
